import type { Transition } from 'framer-motion';

export const overlay = {
  variants: {
    start: {
      backgroundColor: 'rgba(var(--modal-overlay-rgb), 0)',
    },
    open: {
      backgroundColor: 'rgba(var(--modal-overlay-rgb), 0.5)',
    },
    close: {
      backgroundColor: 'rgba(var(--modal-overlay-rgb), 0)',
      transition: {
        duration: 0.15,
      },
    },
  },
  transition: {
    type: 'tween',
    duration: 0.25,
    ease: [0.215, 0.61, 0.355, 1],
  } satisfies Transition,
};

export const main = {
  variants: {
    start: {
      translateY: '100%',
      opacity: 0,
    },
    open: {
      translateY: '0%',
      opacity: 1,
    },
    close: {
      translateY: '20%',
      opacity: 0,
      transition: {
        duration: 0.15,
      },
    },
  },
  transition: {
    type: 'tween',
    duration: 0.5,
    ease: [0.215, 0.61, 0.355, 1],
  } satisfies Transition,
};
